export default __webpack_public_path__ + "static/logo-379aee4fda5a7e8108009bf437b7bc83.png";